// extracted by mini-css-extract-plugin
export default {"chat-channels-list":"ConversationsList_chat-channels-list__j2NXe"};